const imageSliders = document.querySelectorAll('[data-slider="image-slider"]');

const imageSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  breakpoints: {
    1024: {
      spaceBetween: 20,
    },
  },
};

imageSliders.forEach((el) => new Swiper(el, imageSliderOptions));
